export default "__VITE_ASSET__Dd_salua__"